import styled from 'styled-components';
import { Flex, Margin } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const NotConnectedImg = styled.img`
  width: 74.7rem;
`;

const NotConnectedState = ({
  notConnectedImg,
  title,
  info,
  afterButtonInfo,
  image,
  buttons = []
}) => {
  if (!title) {
    return null;
  }
  const ActionButton = (text, icon, onClick) => (
    <Margin r='x-small' key={text}>
      <LBButton variant='outline' size='lg' onClick={onClick} startIcon={icon}>
        {text}
      </LBButton>
    </Margin>
  );
  return (
    <Flex items='center' justify='center' height='100%'>
      <NotConnectedImg src={notConnectedImg} alt='' />
      <Flex
        ml='big'
        direction='column'
        items='flex-start'
        justify='center'
        width='30rem'
      >
        <img src={image} alt='' />
        <Margin t='medium'>
          <Text color='shark' size='x-x-x-large' weight='300'>
            {title}
          </Text>
        </Margin>
        <Margin t='small' b='small'>
          <Text lineHeight='1.5' color='shark' size='large'>
            {info}
          </Text>
        </Margin>
        <Flex items='center'>
          {buttons.map(({ text, icon, onClick }) =>
            ActionButton(text, icon, onClick)
          )}
        </Flex>
        {!!afterButtonInfo && (
          <Margin t='medium'>
            <Text lineHeight='1.5' color='shuttleGray' size='small'>
              {afterButtonInfo}
            </Text>
          </Margin>
        )}
      </Flex>
    </Flex>
  );
};

export default NotConnectedState;
